import { AppState } from '../reducers';

export const selectDashboardUsersState = (state: AppState) =>
    state.dashboardUsers;
export const selectDashboardUserError = (state: AppState) =>
    state.dashboardUsers.error;
